// Ids must be kept in sync with database table Lexbe_CaseConfigTypes
export enum CaseConfigTypeId {
	UseCaseDocumentIngestionWorkflow = 'cf4e5d52-9927-f011-ba9f-0255334540d7',
	DisableCloudConvert = 'a790eae6-9138-ea11-a9c3-121a0f91a96a',
	UseGigabytesCase = '87742050-bf7f-ec11-8311-123745086745',
	UseOpenSearchDynamicQuery = 'acda6d1b-c578-ec11-8310-123745086745',
	EnableKnowledgeBase = '4800c6a2-fda9-4de9-811d-1f01eeb2081b'
}
